module.exports = __webpack_public_path__ + "static/media/1 14 godt.3084206e.mp3";